import { writable } from "svelte/store";

export const loading = writable({ state: false, reason: "" });

export const setLoading = (state, reason) => loading.set({ state, reason });
